import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

export interface LookupItemModel {
    id: number;
    name?: string | null;
    localeKey?: string | null;
    selected: boolean;
}

type LookupState = {
    states: LookupItemModel[];
    waitingStates: LookupItemModel[];
    salutations: LookupItemModel[];
    correspondences: LookupItemModel[];
    documentTypes: LookupItemModel[];
    dueTypes: LookupItemModel[];
    relationTypes: LookupItemModel[];
    years: LookupItemModel[];
    residencePermits: LookupItemModel[];
    memberStateTypes: LookupItemModel[];
    systemMemberStateTypes: LookupItemModel[];
    allMemberStateTypes: LookupItemModel[];
};

const initialState: LookupState = {
    states: [],
    waitingStates: [],
    salutations: [],
    correspondences: [],
    documentTypes: [],
    dueTypes: [],
    relationTypes: [],
    years: [],
    residencePermits: [],
    memberStateTypes: [],
    systemMemberStateTypes: [],
    allMemberStateTypes: []
};

export const LookupStore = signalStore(
    { providedIn: 'root' },
    withState(initialState),
    withMethods((store) => ({
        setStates(states: LookupItemModel[]): void {
            patchState(store, (state) => ({ ...state, states }));
        },
        setWaitingStates(waitingStates: LookupItemModel[]): void {
            patchState(store, (state) => ({ ...state, waitingStates }));
        },
        setSalutations(salutations: LookupItemModel[]): void {
            patchState(store, (state) => ({ ...state, salutations }));
        },
        setCorrespondence(correspondences: LookupItemModel[]): void {
            patchState(store, (state) => ({ ...state, correspondences }));
        },
        setDocumentTypes(documentTypes: LookupItemModel[]): void {
            patchState(store, (state) => ({ ...state, documentTypes }));
        },
        setDueTypes(dueTypes: LookupItemModel[]): void {
            patchState(store, (state) => ({ ...state, dueTypes }));
        },
        setRelationTypes(relationTypes: LookupItemModel[]): void {
            patchState(store, (state) => ({ ...state, relationTypes }));
        },
        setYears(years: LookupItemModel[]): void {
            patchState(store, (state) => ({ ...state, years }));
        },
        setResidencePermits(residencePermits: LookupItemModel[]): void {
            patchState(store, (state) => ({ ...state, residencePermits }));
        },
        setMemberStateTypes(memberStateTypes: LookupItemModel[]): void {
            patchState(store, (state) => ({ ...state, memberStateTypes }));
        },
        setSystemMemberStateTypes(systemMemberStateTypes: LookupItemModel[]): void {
            patchState(store, (state) => ({ ...state, systemMemberStateTypes }));
        },
        setAllMemberStateTypes(allMemberStateTypes: LookupItemModel[]): void {
            patchState(store, (state) => ({ ...state, allMemberStateTypes }));
        }
    }))
);
